<template>
  <div class="ion-page">
    <ion-content class="ion-padding">
      <ion-row>
        <h1>Bienvenido a nuestro Sistema de Citas</h1>
        <img class="logo" src="img/logo-large.png" />
        <h6>
          Seleccione la especialidad, la fecha y rellene sus datos de contacto.
        </h6>
        <ion-button color="tertiary" @click="goToSpecialties">
          Seleccionar especialidad
          <ion-icon slot="end" name="arrow-forward" />
        </ion-button>
      </ion-row>
    </ion-content>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    async goToSpecialties() {
      this.$router.push('specialties')
    },
  },
}
</script>

<style scoped>
ion-content {
  --background: #ededed;
  text-align: center;
}

ion-row {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 20%;
  -webkit-transform: translateX(-20%) translateY(-50%);
  transform: translateX(-20%) translateY(-50%);
}

h1,
h6 {
  width: 80%;
  margin-left: 10%;
  color: #373737;
}

ion-button {
  width: 80%;
  margin: 30px 10%;
}

img {
  width: 300px;
  margin: 10% calc(50% - 150px);
}
</style>
